import { makeStyles, Tooltip } from '@material-ui/core'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  tooltip: {
    backgroundColor: '#E2EBFD',
    color: '#000',
    fontSize: 14,
    padding: '8px 10px'
  },
  arrow: {
    color: '#E2EBFD'
  },
  trigger: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  icon: {
    fontSize: 18,
    color: '#94004A'
  },
  indicatorText: {
    marginRight: 4,
    fontSize: 12,
    color: '#94004A',
  }
}))

const CreditStatusTooltip: React.FC = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const indicatorText = t('tooltips.applications.creditStatusIndicator')

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        arrow
        interactive
        classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
        open={open}
        onClose={() => setOpen(false)}
        disableHoverListener
        disableFocusListener
        disableTouchListener
        title={
          <div>
            <div>{t('tooltips.applications.creditStatusLine0')}</div>
            <div>{t('tooltips.applications.creditStatusLine1')}</div>
          </div>
        }
      >
        <span
          onClick={() => setOpen(!open)}
          role='button'
          aria-label='credit-status-info'
          className={classes.trigger}
        >
          {indicatorText && (
            <span className={classes.indicatorText}>{indicatorText}</span>
          )}
          <InfoOutlinedIcon className={classes.icon} />
        </span>
      </Tooltip>
    </ClickAwayListener>
  )
}

export default CreditStatusTooltip
